"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");
var _typeof = require("@babel/runtime/helpers/typeof");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;
var _extends2 = _interopRequireDefault(require("@babel/runtime/helpers/extends"));
var _react = _interopRequireWildcard(require("react"));
var React = _react;
function _getRequireWildcardCache(e) { if ("function" != typeof WeakMap) return null; var r = new WeakMap(), t = new WeakMap(); return (_getRequireWildcardCache = function _getRequireWildcardCache(e) { return e ? t : r; })(e); }
function _interopRequireWildcard(e, r) { if (!r && e && e.__esModule) return e; if (null === e || "object" != _typeof(e) && "function" != typeof e) return { "default": e }; var t = _getRequireWildcardCache(r); if (t && t.has(e)) return t.get(e); var n = { __proto__: null }, a = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var u in e) if ("default" !== u && {}.hasOwnProperty.call(e, u)) { var i = a ? Object.getOwnPropertyDescriptor(e, u) : null; i && (i.get || i.set) ? Object.defineProperty(n, u, i) : n[u] = e[u]; } return n["default"] = e, t && t.set(e, n), n; }
/**
 * НЕ РЕДАКТИРОВАТЬ
 *
 * Этот файл создан автоматически с помощью svgr
 *
 * Подробнее, как работать с иконками:
 * @see https://lvtv.me/icons
 */
var SvgExtraBed = function SvgExtraBed(props) {
  return /*#__PURE__*/React.createElement("svg", (0, _extends2["default"])({
    viewBox: "0 0 24 24",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), /*#__PURE__*/React.createElement("g", {
    transform: "translate(1 2)",
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M4 10.5A1.5 1.5 0 0 0 2.5 12v4.027a.5.5 0 0 0 .5.5h18.033a.5.5 0 0 0 .5-.5V12a1.5 1.5 0 0 0-1.5-1.5H4z",
    stroke: "#4D4D4D"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M3 16h3v1a1 1 0 0 1-1 1H4a1 1 0 0 1-1-1v-1zm15 0h3v1a1 1 0 0 1-1 1h-1a1 1 0 0 1-1-1v-1z",
    fill: "#4D4D4D"
  }), /*#__PURE__*/React.createElement("path", {
    stroke: "#4A4A4A",
    d: "M4.5 4.5h15v6h-15z"
  }), /*#__PURE__*/React.createElement("rect", {
    stroke: "#4D4D4D",
    x: 6.5,
    y: 8.5,
    width: 5,
    height: 2,
    rx: 1
  }), /*#__PURE__*/React.createElement("rect", {
    stroke: "#4D4D4D",
    x: 12.5,
    y: 8.5,
    width: 5,
    height: 2,
    rx: 1
  }), /*#__PURE__*/React.createElement("g", {
    fill: "#4D4D4D"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M2 0h1v5H2z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M5 2v1H0V2z"
  }))));
};
var Memo = /*#__PURE__*/(0, _react.memo)(SvgExtraBed);
var _default = exports["default"] = Memo;